// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-content {
  --background: #ffffff;
}

#container-demo-pass {
  border-radius: 100px;
  background: var(--Input-Box-Filled-Active, #FFF);
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.2) inset;
  padding: 16px 25px;
  width: 100%;
  margin-top: 8px;
}
#container-demo-pass img {
  position: relative;
  top: 3px;
}

#container-code .title {
  color: var(--text-Subttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  margin-bottom: 8px;
}
#container-code .detail {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  margin-bottom: 2px;
}
#container-code .email {
  color: var(--text-BODY, #2C4051);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 0px;
}
#container-code .code-send {
  color: var(--text-Info, #788089);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 4px;
  padding-left: 5px;
  margin-top: 0px;
}
#container-code .item-form {
  border-radius: 16px;
  border: 1px solid var(--Brand-Primario, #0554F2);
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.2) inset;
}
#container-code .item-invalid {
  --background: #F0F0F0;
  --box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.20) inset;
  border: 1px solid #e1e1e1 !important;
  pointer-events: none;
  height: 56px;
  border-radius: 16px;
}
#container-code ::ng-deep .custom-input .label-text {
  color: #788089;
}
#container-code ::ng-deep .custom-input {
  color: #788089;
  font-family: "Montserrat";
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  margin-bottom: 0px;
}
#container-code .send-code {
  color: var(--ion-color-primary);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 7px;
  padding-left: 6px;
}
#container-code .lock-resend {
  color: #96BFF3 !important;
  pointer-events: none;
}
#container-code .no-code {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 7px;
  padding-left: 6px;
}
#container-code .no-code .new-code {
  color: var(--ion-color-primary);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
#container-code .error-code {
  color: var(--UI-Error, #D50000);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 7px;
  padding-left: 6px;
  margin-bottom: 0px;
}

#container-pass .title {
  color: var(--text-Subttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: left;
  padding-left: 8px;
  margin-bottom: 6px;
}
#container-pass .item-form {
  border-radius: 16px;
  border: 1px solid #ededed;
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.2) inset;
}
#container-pass .item-invalid {
  --background: #F0F0F0;
  --box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.20) inset;
  border: 1px solid #e1e1e1 !important;
  pointer-events: none;
}
#container-pass ::ng-deep .custom-input .label-text {
  color: #788089;
}
#container-pass ::ng-deep .custom-input {
  color: #788089;
  font-family: "Montserrat";
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  margin-bottom: 0px;
}
#container-pass ::ng-deep .disable-input {
  color: var(--text-Info, #788089) !important;
}
#container-pass .container-validation {
  margin-bottom: 16px;
  padding-left: 8px;
}
#container-pass .container-validation p {
  color: #788089;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  margin-top: 6px;
  display: flex;
  align-items: center;
}
#container-pass .container-validation p ion-icon {
  width: 16px;
  border-radius: 50%;
  height: 16px;
  background: #788089;
  color: #fff;
}
#container-pass .container-validation .error {
  color: #788089;
}
#container-pass .container-validation .success {
  color: #099F69;
}
#container-pass .container-validation .success ion-icon {
  background: #099F69;
  color: #fff;
}

#container-success {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 8px;
}
#container-success .img-success {
  width: 120px;
  height: 120px;
  margin-bottom: 16px;
}
#container-success .title {
  color: var(--text-Subttulos, #0D253A);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 0px;
}
#container-success .detail {
  color: var(--text-BODY, #2C4051);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.btn-action ion-spinner {
  margin-right: 10px;
}

.recovery-form .custom-item-form {
  border-radius: 16px;
  border: 1px solid var(--ion-color-primary);
  background: #FFF;
  margin-bottom: 0px;
  --padding-start: 16px;
  --padding-end: 16px;
}
.recovery-form .custom-item-form ::ng-deep .required-indicator .label-text::after {
  content: "*";
  transform: translate(-100%, 0);
  color: red !important;
  padding-left: 5px;
}
.recovery-form .custom-item-form ::ng-deep .custom-input .label-text {
  color: var(--ion-color-primary) !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Roboto";
  font-size: 16px !important;
}
.recovery-form .custom-item-form ::ng-deep .custom-input {
  color: #0D253A !important;
  font-family: "Poppins";
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  bottom: 2px;
}
.recovery-form .custom-item-form ::ng-deep .disable-input .label-text {
  color: var(--text-Info, #788089) !important;
}

.error-pass {
  margin-top: 0px;
  margin-bottom: 5px;
  padding-left: 5px;
  position: relative;
  top: 5px;
  font-size: 13px;
  color: red;
}

ion-footer {
  box-shadow: none !important;
  --box-shadow: none !important; /* Para asegurarse de eliminar cualquier sombra aplicada */
}`, "",{"version":3,"sources":["webpack://./src/app/pages/support/components/delete-account/delete-account.page.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,gDAAA;EACA,oDAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AACJ;AACI;EACI,kBAAA;EACA,QAAA;AACR;;AAII;EACI,qCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AADR;AAII;EACI,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAFR;AAKI;EACI,gCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAHR;AAMI;EACI,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAJR;AAOI;EACI,mBAAA;EACA,gDAAA;EACA,oDAAA;AALR;AAQI;EACI,qBAAA;EACA,uDAAA;EACA,oCAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;AANR;AAiBI;EACI,cAAA;AAfR;AAkBI;EACI,cAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EAEA,mBAAA;EACA,kBAAA;AAjBR;AA6BI;EACI,+BAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA3BR;AA8BI;EACI,yBAAA;EACA,oBAAA;AA5BR;AA+BI;EACI,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA7BR;AA+BQ;EACI,+BAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA7BZ;AAiCI;EACI,+BAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA/BR;;AAoCI;EACI,qCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAjCR;AAoCI;EACI,mBAAA;EACA,yBAAA;EACA,oDAAA;AAlCR;AAqCI;EACI,qBAAA;EACA,uDAAA;EACA,oCAAA;EACA,oBAAA;AAnCR;AAsCI;EACI,cAAA;AApCR;AAuCI;EACI,cAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EAEA,mBAAA;EACA,kBAAA;AAtCR;AAyCI;EACI,2CAAA;AAvCR;AA4CI;EACI,mBAAA;EACA,iBAAA;AA1CR;AA4CQ;EACI,cAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AA1CZ;AA4CY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AA1ChB;AA8CQ;EACI,cAAA;AA5CZ;AA+CQ;EACI,cAAA;AA7CZ;AA+CY;EACI,mBAAA;EACA,WAAA;AA7ChB;;AAmDA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAhDJ;AAkDI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AAhDR;AAmDI;EACI,qCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAjDR;AAoDI;EACI,gCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlDR;;AAuDI;EACI,kBAAA;AApDR;;AA0DI;EACI,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AAvDR;AA2DQ;EACI,YAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;AAzDZ;AA8DQ;EACI,0CAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;AA5DZ;AA+DQ;EACI,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AA7DZ;AAiEQ;EACI,2CAAA;AA/DZ;;AAqEA;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;AAlEJ;;AAqEE;EACE,2BAAA;EACA,6BAAA,EAAA,0DAAA;AAlEJ","sourcesContent":[".custom-content {\r\n    --background: #ffffff;\r\n}\r\n\r\n#container-demo-pass {\r\n    border-radius: 100px;\r\n    background: var(--Input-Box-Filled-Active, #FFF);\r\n    box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.20) inset;\r\n    padding: 16px 25px;\r\n    width: 100%;\r\n    margin-top: 8px;\r\n\r\n    img {\r\n        position: relative;\r\n        top: 3px;\r\n    }\r\n}\r\n\r\n#container-code {\r\n    .title {\r\n        color: var(--text-Subttulos, #0D253A);\r\n        font-feature-settings: 'liga' off, 'clig' off;\r\n        font-family: 'Poppins';\r\n        font-size: 18px;\r\n        font-style: normal;\r\n        font-weight: 600;\r\n        line-height: normal;\r\n        text-align: center;\r\n        margin-bottom: 8px;\r\n    }\r\n\r\n    .detail {\r\n        color: var(--text-BODY, #2C4051);\r\n        font-feature-settings: 'liga' off, 'clig' off;\r\n        font-family: 'Poppins';\r\n        font-size: 16px;\r\n        font-style: normal;\r\n        font-weight: 400;\r\n        line-height: normal;\r\n        text-align: center;\r\n        margin-bottom: 2px;\r\n    }\r\n\r\n    .email {\r\n        color: var(--text-BODY, #2C4051);\r\n        text-align: center;\r\n        font-feature-settings: 'liga' off, 'clig' off;\r\n        font-family: 'Poppins';\r\n        font-size: 16px;\r\n        font-style: normal;\r\n        font-weight: 400;\r\n        line-height: normal;\r\n        text-align: center;\r\n        margin-top: 0px;\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .code-send {\r\n        color: var(--text-Info, #788089);\r\n        font-feature-settings: 'liga' off, 'clig' off;\r\n        font-family: 'Poppins';\r\n        font-size: 12px;\r\n        font-style: normal;\r\n        font-weight: 400;\r\n        line-height: normal;\r\n        margin-bottom: 4px;\r\n        padding-left: 5px;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .item-form {\r\n        border-radius: 16px;\r\n        border: 1px solid var(--Brand-Primario, #0554F2);\r\n        box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.20) inset;\r\n    }\r\n\r\n    .item-invalid {\r\n        --background: #F0F0F0;\r\n        --box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.20) inset;\r\n        border: 1px solid #e1e1e1 !important;\r\n        pointer-events: none;\r\n        height: 56px;\r\n        border-radius: 16px;\r\n    }\r\n\r\n    // ::ng-deep .custom-input .label-text::after {\r\n    //     content: '*';\r\n    //     transform: translate(-100%, 0);\r\n    //     color: red !important;\r\n    //     //font-weight: bolder;\r\n    //     padding-left: 5px;\r\n    // }\r\n\r\n    ::ng-deep .custom-input .label-text {\r\n        color: #788089;\r\n    }\r\n\r\n    ::ng-deep .custom-input {\r\n        color: #788089;\r\n        font-family: \"Montserrat\";\r\n        font-size: 16px;\r\n        font-style: normal;\r\n        //font-weight: 500;\r\n        line-height: normal;\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    // ::ng-deep .no-required {\r\n    //     color: #393B3F;\r\n    //     font-family: \"Montserrat\";\r\n    //     font-size: 16px;\r\n    //     font-style: normal;\r\n    //     //font-weight: 500;\r\n    //     line-height: normal;\r\n    // }\r\n\r\n    .send-code {\r\n        color: var(--ion-color-primary);\r\n        font-feature-settings: \"liga\" off, \"clig\" off;\r\n        font-family: \"Poppins\";\r\n        font-size: 15px;\r\n        font-style: normal;\r\n        font-weight: 500;\r\n        line-height: normal;\r\n        margin-top: 7px;\r\n        padding-left: 6px;\r\n    }\r\n\r\n    .lock-resend{\r\n        color: #96BFF3 !important;\r\n        pointer-events: none;\r\n    }\r\n\r\n    .no-code {\r\n        color: var(--text-BODY, #2C4051);\r\n        font-feature-settings: 'liga' off, 'clig' off;\r\n        font-family: 'Poppins';\r\n        font-size: 14px;\r\n        font-style: normal;\r\n        font-weight: 400;\r\n        line-height: normal;\r\n        margin-top: 7px;\r\n        padding-left: 6px;\r\n\r\n        .new-code {\r\n            color: var(--ion-color-primary);\r\n            font-feature-settings: 'liga' off, 'clig' off;\r\n            font-family: 'Poppins';\r\n            font-size: 14px;\r\n            font-style: normal;\r\n            font-weight: 500;\r\n            line-height: normal;\r\n        }\r\n    }\r\n\r\n    .error-code {\r\n        color: var(--UI-Error, #D50000);\r\n        font-feature-settings: 'liga' off, 'clig' off;\r\n        font-family: 'Poppins';\r\n        font-size: 12px;\r\n        font-style: normal;\r\n        font-weight: 400;\r\n        line-height: normal;\r\n        margin-top: 7px;\r\n        padding-left: 6px;\r\n        margin-bottom: 0px;\r\n    }\r\n}\r\n\r\n#container-pass {\r\n    .title {\r\n        color: var(--text-Subttulos, #0D253A);\r\n        font-feature-settings: 'liga' off, 'clig' off;\r\n        font-family: 'Poppins';\r\n        font-size: 18px;\r\n        font-style: normal;\r\n        font-weight: 600;\r\n        line-height: normal;\r\n        text-align: left;\r\n        padding-left: 8px;\r\n        margin-bottom: 6px;\r\n    }\r\n\r\n    .item-form {\r\n        border-radius: 16px;\r\n        border: 1px solid #ededed;\r\n        box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.20) inset;\r\n    }\r\n\r\n    .item-invalid {\r\n        --background: #F0F0F0;\r\n        --box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.20) inset;\r\n        border: 1px solid #e1e1e1 !important;\r\n        pointer-events: none;\r\n    }\r\n\r\n    ::ng-deep .custom-input .label-text {\r\n        color: #788089;\r\n    }\r\n\r\n    ::ng-deep .custom-input {\r\n        color: #788089;\r\n        font-family: \"Montserrat\";\r\n        font-size: 16px;\r\n        font-style: normal;\r\n        //font-weight: 500;\r\n        line-height: normal;\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    ::ng-deep .disable-input {\r\n        color: var(--text-Info, #788089) !important;\r\n    }\r\n\r\n\r\n\r\n    .container-validation {\r\n        margin-bottom: 16px;\r\n        padding-left: 8px;\r\n\r\n        p {\r\n            color: #788089;\r\n            font-feature-settings: 'liga' off, 'clig' off;\r\n            font-family: 'Poppins';\r\n            font-size: 13px;\r\n            font-style: normal;\r\n            font-weight: 400;\r\n            line-height: normal;\r\n            margin-bottom: 0px;\r\n            margin-top: 6px;\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            ion-icon {\r\n                width: 16px;\r\n                border-radius: 50%;\r\n                height: 16px;\r\n                background: #788089;\r\n                color: #fff;\r\n            }\r\n        }\r\n\r\n        .error {\r\n            color: #788089;\r\n        }\r\n\r\n        .success {\r\n            color: #099F69;\r\n\r\n            ion-icon{\r\n                background: #099F69;\r\n                color: #fff;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n#container-success {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 0px 8px;\r\n\r\n    .img-success {\r\n        width: 120px;\r\n        height: 120px;\r\n        margin-bottom: 16px;\r\n    }\r\n\r\n    .title {\r\n        color: var(--text-Subttulos, #0D253A);\r\n        text-align: center;\r\n        font-feature-settings: 'liga' off, 'clig' off;\r\n        font-family: 'Poppins';\r\n        font-size: 20px;\r\n        font-style: normal;\r\n        font-weight: 600;\r\n        line-height: normal;\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .detail {\r\n        color: var(--text-BODY, #2C4051);\r\n        text-align: center;\r\n        font-feature-settings: 'liga' off, 'clig' off;\r\n        font-family: 'Poppins';\r\n        font-size: 16px;\r\n        font-style: normal;\r\n        font-weight: 500;\r\n        line-height: normal;\r\n    }\r\n}\r\n\r\n.btn-action {\r\n    ion-spinner {\r\n        margin-right: 10px;\r\n    }\r\n}\r\n\r\n.recovery-form {\r\n\r\n    .custom-item-form {\r\n        border-radius: 16px;\r\n        border: 1px solid var(--ion-color-primary);\r\n        background: #FFF;\r\n        margin-bottom: 0px;\r\n        --padding-start: 16px;\r\n        --padding-end: 16px;\r\n    }\r\n\r\n    .custom-item-form {\r\n        ::ng-deep .required-indicator .label-text::after {\r\n            content: '*';\r\n            transform: translate(-100%, 0);\r\n            color: red !important;\r\n            padding-left: 5px;\r\n        }\r\n    }\r\n\r\n    .custom-item-form {\r\n        ::ng-deep .custom-input .label-text {\r\n            color: var(--ion-color-primary) !important;\r\n            font-feature-settings: \"liga\" off, \"clig\" off;\r\n            font-family: \"Roboto\";\r\n            font-size: 16px !important;\r\n        }\r\n\r\n        ::ng-deep .custom-input {\r\n            color: #0D253A !important;\r\n            font-family: \"Poppins\";\r\n            font-size: 16px !important;\r\n            font-style: normal;\r\n            font-weight: 400;\r\n            line-height: normal;\r\n            margin-bottom: 0px;\r\n            bottom: 2px;\r\n        }\r\n\r\n\r\n        ::ng-deep .disable-input .label-text {\r\n            color: var(--text-Info, #788089) !important;\r\n        }\r\n\r\n    }\r\n}\r\n\r\n.error-pass {\r\n    margin-top: 0px;\r\n    margin-bottom: 5px;\r\n    padding-left: 5px;\r\n    position: relative;\r\n    top: 5px;\r\n    font-size: 13px;\r\n    color: red;\r\n  }\r\n\r\n  ion-footer {\r\n    box-shadow: none !important;\r\n    --box-shadow: none !important; /* Para asegurarse de eliminar cualquier sombra aplicada */\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
